export const SalesSquareMeterType = {
    venda: "Venda",
    orcamento: "Orçamento",
}